import { ValueFormatterParams } from "@ag-grid-community/core";

import { formatPercent } from "fond/utils/number";

const numberPercentValueFormatter = ({ value }: ValueFormatterParams): string => formatPercent(value);

export default numberPercentValueFormatter;
